import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NbSecurityModule } from '@nebular/security';
import { SharedModule } from '~app/shared/shared.module';
import { LicensesModule } from '../../pages/licenses/licenses.module';
import { VersionsModule } from '../applications/versions/versions.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { DeveloperAppsCardComponent } from './developer-apps-card/developer-apps-card.component';

@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    LicensesModule,
    SharedModule,
    NbSecurityModule,
    VersionsModule
  ],
  declarations: [DashboardComponent, DeveloperAppsCardComponent]
})
export class DashboardModule {}
